import { fetchData, apiURL } from './api_helper';

const getStudentProfile = (classId, studentId) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/classes/${classId}/students/${studentId}/profile`;
    fetchData(endpointURL, 'GET')
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getStudentSkillStats = studentId => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/students/${studentId}/skillStats`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getStudentLatestAssignments = (classId, studentId, counter) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/students/${studentId}/assignments/latest/${counter}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getStudentSuggestedTasks = (studentId, counter) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/students/${studentId}/lessons/suggestedByInterests/${counter}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});
// eslint-disable-next-line
const getStudentOpenAssignments = (classId, studentId, page, limit, order, direction) => new Promise((resolve, reject) => {
  // eslint-disable-next-line max-len
  const endpointURL = `${apiURL}/api/v2/classes/${classId}/students/${studentId}/assignments/open/${page}?limit=${limit}&order=${order}&direction=${direction}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});
// eslint-disable-next-line
const getStudentClosedAssignments = (classId, studentId, page, limit, order, direction) => new Promise((resolve, reject) => {
  // eslint-disable-next-line max-len
  const endpointURL = `${apiURL}/api/classes/${classId}/students/${studentId}/assignments/closed/${page}?limit=${limit}&order=${order}&direction=${direction}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getStudentActivity = (studentId, page, limit, order, direction) => new Promise((resolve, reject) => {
  // eslint-disable-next-line
  const endpointURL = `${apiURL}/api/students/${studentId}/activityLog/${page}?limit=${limit}&order=${order}&direction=${direction}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getStudentPracticeWeaknesses = studentId => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/students/${studentId}/lessons/practiceWeaknesses`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getVocabularyList = (studentId, type, page) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/students/${studentId}/vocabulary/${type}/${page}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getSuggestedWeakWords = (studentId, language) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/students/${studentId}/suggestWeakWords?language=${language}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getStudentReport = (classId, studentId, interval) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/students/${studentId}/reports/${interval}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getStudentReportOverview = (classId, studentId) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/students/${studentId}/reportOverview`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const downloadStudentReportForPdf = (classId, studentId, interval) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/students/${studentId}/reports/${interval}/pdf`;
  fetchData(endpointURL, 'GET', { generatePdf: true })
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const grammarSuccessRatesForStudents = students => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/students/grammarSuccessRatesForStudents`;
  fetchData(endpointURL, 'POST', students)
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const updateStudentStats = studentIds => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/students/updateStats`;
  fetchData(endpointURL, 'POST', studentIds)
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

export default {
  getStudentProfile,
  getStudentSkillStats,
  getStudentLatestAssignments,
  getStudentSuggestedTasks,
  getStudentOpenAssignments,
  getStudentClosedAssignments,
  getStudentActivity,
  getStudentPracticeWeaknesses,
  getVocabularyList,
  getSuggestedWeakWords,
  getStudentReport,
  getStudentReportOverview,
  downloadStudentReportForPdf,
  grammarSuccessRatesForStudents,
  updateStudentStats
};



// WEBPACK FOOTER //
// ./src/api/students.js